import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { firstValueFrom } from "rxjs";

export interface SchoolConfig {
  id: number;
  favicon: string;
  theme: string;
  fileDomain?: string;   // optional, e.g. "https://jjis.co.in"; defaults to current domain
  layout?: {
    header?: string;
    home?: string;
    carousel?: string;
  };
}

@Injectable({ providedIn: 'root' })
export class SchoolMapService {

  private map: Record<string, SchoolConfig> = {};

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    const data = await firstValueFrom(
      this.http.get<Record<string, SchoolConfig>>('/assets/school-map.json')
    );

    this.map = data ?? {};
  }

  private getHost(): string {
    return window.location.hostname.toLowerCase();
  }

  getSchoolConfig(): SchoolConfig | null {
    const host = this.getHost();
    return this.map[host] ?? this.map['localhost'] ?? null;
  }

  getSchoolId(): number {
    return this.getSchoolConfig()?.id ?? 0;
  }

  getFavicon(): string | null {
    return this.getSchoolConfig()?.favicon ?? null;
  }

  getOrigin(): string {
    return this.getSchoolConfig()?.fileDomain ?? window.location.origin;
  }

  getTheme(): string | null {
    return this.getSchoolConfig()?.theme ?? null;
  }

  getLayout() {
  return this.getSchoolConfig()?.layout || {};
}

getHeaderType(): string {
  return this.getLayout().header || 'header-1';
}

getCarouselType(): string {
  return this.getLayout().carousel || 'carousel-1';
}

getHomeType(): string {
  return this.getLayout().home || 'home-1';
}
}
